import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import React from 'react';
import { ModalProps } from '../../types/modal';
import { SetMenu } from '../../types/set-menu';
import { useDeleteSetMenuMutation } from '../../../app/Slices/SevenDayApiSlice';
import toast from '../../shared/Toast';

interface SetMenuDeleteModalProps extends ModalProps {
    setMenu: SetMenu | null;
}

const SetMenuDeleteModal = ({
    open,
    onClose,
    setMenu,
}: SetMenuDeleteModalProps) => {
    const [deleteSetMenu] = useDeleteSetMenuMutation();

    const handleDelete = async () => {
        try {
            if (!setMenu?.id) return;

            await deleteSetMenu(setMenu.id).unwrap();

            onClose();
            toast.success('Set menu deleted successfully');
        } catch (error: any) {
            toast.error(error?.data?.message ?? 'Error deleting set menu');
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                Delete Set Menu
                <IconButton
                    onClick={onClose}
                    sx={{ color: 'text.primary' }}
                    aria-label='close'
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={1}>
                    <Typography>
                        Are you sure you want to delete <b>{setMenu?.name}</b>?
                    </Typography>
                    <Alert severity='warning'>
                        This action cannot be undone
                    </Alert>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant='contained'
                    color='error'
                    onClick={handleDelete}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SetMenuDeleteModal;
